export const HOSTED_MCP_URL = 'https://mcp.rushdb.com/mcp'

export const AGENT_SETUP_URL = 'https://rushdb.com/agent-setup'

export const connectDocsUrls = {
  overview: 'https://docs.rushdb.com/connect',
  mcp: 'https://docs.rushdb.com/connect/mcp',
  skills: 'https://docs.rushdb.com/connect/skills',
  sdk: 'https://docs.rushdb.com/connect/sdks',
  memory: 'https://docs.rushdb.com/build/agent-memory/quickstart'
}
